import { render } from "./BuildPool.vue?vue&type=template&id=6d8870da&scoped=true&ts=true"
import script from "./BuildPool.vue?vue&type=script&lang=ts"
export * from "./BuildPool.vue?vue&type=script&lang=ts"

import "./BuildPool.vue?vue&type=style&index=0&id=6d8870da&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8870da"]])

export default __exports__